module.exports = __webpack_public_path__ + "static/img/3.f2c4b4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/3.png
// module id = 5fZL
// module chunks = 0